import React, { useState, useRef } from "react"
import { TextField } from "@mui/material"

const BarcodeInput = ({ onScan }) => {
  const [barcode, setBarcode] = useState("")
  const inputRef = useRef(null)
  const scanLock = useRef(false)

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault()

      if (!scanLock.current) {
        const trimmed = barcode.trim()
        if (!trimmed) return

        scanLock.current = true

        // 🔔 Call the parent handler with scanned value
        onScan?.(trimmed)

        // Reset input
        setBarcode("")
        if (inputRef.current) inputRef.current.value = ""

        // Unlock after a short delay
        setTimeout(() => {
          scanLock.current = false
        }, 500)
      } else {
        // Debounce extra scans
        setBarcode("")
        if (inputRef.current) inputRef.current.value = ""
      }
    }
  }

  return (
    <TextField
      inputRef={inputRef}
      fullWidth
      label="Barcode"
      value={barcode}
      onChange={(e) => setBarcode(e.target.value)}
      onKeyDown={handleKeyDown}
      autoFocus
    />
  )
}

export default BarcodeInput
